var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500.000000pt",
    height: "500.000000pt",
    viewBox: "0 0 500.000000 500.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,500.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1538 3990 c-142 -17 -262 -74 -358 -170 -75 -75 -119 -152 -152 -265 l-23 -80 0 -975 c0 -1089 -4 -1025 72 -1179 44 -91 141 -192 228 -238 34 -18 97 -42 140 -55 l80 -23 975 0 c899 0 980 1 1040 18 225 61 376 212 437 437 17 60 18 141 18 1040 0 899 -1 980 -18 1040 -59 220 -200 365 -417 431 l-75 23 -940 2 c-517 1 -970 -2 -1007 -6z m338 -605 c112 -33 173 -161 134 -279 -14 -43 -85 -109 -135 -126 -86 -28 -189 10 -242 92 -24 36 -28 52 -28 113 0 61 4 77 27 113 31 46 59 68 116 88 48 17 68 17 128 -1z m1202 -589 c125 -34 228 -126 284 -254 l33 -77 3 -437 3 -438 -181 0 -180 0 0 343 c0 280 -3 353 -15 395 -32 108 -138 166 -260 143 -77 -14 -132 -52 -164 -116 l-26 -49 -3 -358 -3 -358 -184 0 -185 0 0 600 0 600 175 0 175 0 0 -82 0 -81 37 38 c49 50 128 99 199 124 72 25 213 28 292 7z m-1078 -606 l0 -600 -185 0 -185 0 0 600 0 600 185 0 185 0 0 -600z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.00837d52dfdfb36492b234f0faebadd3.svg";
export { ForwardRef as ReactComponent };